module.exports = __webpack_public_path__ + "static/media/projectmgmt.05412805.jpeg";